import { times } from "lodash/fp";

import { Box, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Stack, { Row } from "@rui/Stack";

const MIN_MEETINGS = 5;

const Banner = styled(Stack)(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.shades.orange[100],
  borderRadius: "8px",
  padding: theme.spacing(2),
}));

type DotProps = { filled: boolean };

const Dot = styled(({ filled: _, ...props }: DotProps) => <Box {...props} />)(
  ({ filled, theme }) => ({
    height: "12px",
    width: "12px",
    borderRadius: "50%",
    backgroundColor: filled
      ? theme.palette.shades.primary[500]
      : theme.palette.shades.primary[100],
  })
);

const UnlockCoachingInsights = ({ sessionCount }: { sessionCount: number }) => {
  if (!sessionCount || sessionCount >= MIN_MEETINGS) return null;

  return (
    <Banner spacing={1}>
      <Typography
        variant="h3"
        sx={{ color: "shades.neutral.800", fontWeight: 500 }}
      >
        Unlock more coaching insights
      </Typography>
      <Typography
        variant="bodySecondaryReg"
        sx={{ color: "shades.neutral.700" }}
      >
        After {MIN_MEETINGS} meetings with Read, you'll see more robust coaching
        and trends to help you improve over time.
      </Typography>
      <Row spacing={1} variant="left">
        <Row spacing={0.5}>
          {times(
            (i) => (
              <Dot key={i} filled={i < sessionCount} />
            ),
            MIN_MEETINGS
          )}
        </Row>
        <Typography
          variant="bodySecondaryMed"
          sx={{ color: "shades.neutral.600" }}
        >
          {sessionCount}/{MIN_MEETINGS} meetings
        </Typography>
      </Row>
    </Banner>
  );
};

export default UnlockCoachingInsights;
